import PageLayout from "@/components/layout/PageLayout";
import ExplorePoolsListener from "@nitro-ape/shared/features/explore/listeners/ExplorePoolsListener";
import { createFileRoute } from "@tanstack/react-router";
import { i18n } from "@lingui/core";
import ExploreTable from "./-components/ExploreTable";
import ExploreTableFilters from "./-components/ExploreTableFilters";
import { ExploreFiltersProvider } from "./-providers/explore-filters-provider";
import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";

export const Route = createFileRoute("/_main/explore/")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitleExplore),
      },
    ],
  }),
  component: ExplorePage,
});

function ExplorePage() {
  return (
    <PageLayout>
      <ExploreFiltersProvider>
        <ExplorePoolsListener>
          <div className="flex h-full max-h-full w-full flex-col gap-1.5">
            <ExploreTableFilters />

            <ExploreTable />
          </div>
        </ExplorePoolsListener>
      </ExploreFiltersProvider>
    </PageLayout>
  );
}
